import { Analytics } from '@cobliteam/analytics';
import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { withPermissions } from '@cobliteam/permissions';
import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { useState } from 'react';
import InsightsModal from './components/InsightsModal';

const InsightsButton = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const { getUser } = useUser();
  const user = getUser();

  const userHasGroupRestrictions = user.groupsRestriction.length > 0;

  if (userHasGroupRestrictions) {
    return null;
  }

  const handleClick = () => {
    Analytics.track('Insights Button Clicked');
    setOpenModal(true);
  };

  const handleOnOpen = (open: boolean) => {
    if (!open) {
      Analytics.track('Insights Modal Closed');
    }
    setOpenModal(open);
  };

  return (
    <div className='justify-center align-middle'>
      <Button onClick={handleClick} variant='outlined' color='default' size='sm' startIcon={<Icon name='sparkles' color='primary' />}>
        Insights
      </Button>
      {openModal ? <InsightsModal open={openModal} onOpen={handleOnOpen} /> : null}
    </div>
  );
};

export default withPermissions({ Component: InsightsButton, permissions: 'view:analytics-and-reports' });
